



































































import {Component, Vue } from 'vue-property-decorator';
import {DatenschutzFaService} from "../../services/datenschutzfa-service";
import {DatenschutzFa} from "../../models/datenschutzfa-model";
import {containsWoCaseMultipleFn} from "@/helper/global-helper";
import {PageStore, PageStores} from "@/store/modules/page-store";
import DatenschutzFaGesamtansicht from "@/views/DatenschutzFa/DatenschutzFaGesamtansicht.vue";
import {vm} from "@/main";
import {UserModule, UserStore} from "@/store/modules/currentuser-store";
import { GuardileoVueComponent } from '@/lib';

@Component({})
export default class DatenschutzFaList extends GuardileoVueComponent {
    private datenschutzFaService!: DatenschutzFaService;

    public items: DatenschutzFa[] = [];
    private loading: boolean = true;
    public pageStore: PageStore = PageStores.datenschutzFa;
    public userStore: UserModule = UserStore;

    private sortFunc = <T>(a: T[]) => a;

    changeSortFunction(sortFunc: (a: any) => any){
        this.sortFunc = sortFunc;
    }

    get filteredItems() {
        const filtered = this.items.filter((x) => (containsWoCaseMultipleFn(this.pageStore.filter, x.VTaetigkeitName) && this.pageStore.selected.indexOf(x.Status) != -1));
        const presorted = this.sortFunc(filtered);
        const sorted = presorted.sort((a,b) => {
            if(a.IstAktiv && b.IstAktiv) return 0;
            else if(a.IstAktiv) return -1;
            else if(b.IstAktiv) return 1;
            else return 0;
        });
        return sorted;
    }

    created(){
        this.datenschutzFaService = new DatenschutzFaService();
    }

    public async loadItems() {
        try {
            this.loading = true;
            this.items = await this.datenschutzFaService.GetList();
        } catch (error) {
            throw error
        } finally {
            this.loading = false;
        }
    }

    mounted() {
        this.loadItems();
    }

    showGesamtansicht(id: number){
        vm.$modal.show(DatenschutzFaGesamtansicht,
            {id:id},
            {width:"80%", height:"80%", scrollable: true});
    }

    get darf_Datenschutzfolgeabschaetzungen_verwalten(): boolean {
        return this.hat_Berechtigung('Datenschutzfolgeabschaetzungen_bearbeiten');
    }        
}
